<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="6" sm="8">
                    <div class="login-header">
                        <img class="login-logo" src="../../../src/assets/img/codelab-logo.png" alt="Codelab Logo " />
                        <p class="messageWelcome">Register your new account!</p>
                    </div>

                    <b-card-body class="p-4 login-box">
                        <p class="login-headline">Fill in the form below with your details:</p>

                        <Feedback
                            :state="validateRef('registerForm.username')"
                            invalid="This field is required"
                        ></Feedback>
                        <b-input-group class="mb-3">
                            <b-input-group-prepend>
                                <b-input-group-text>
                                    <i class="icon-user"></i>
                                </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input
                                v-model="$v.registerForm.username.$model"
                                type="text"
                                class="form-control"
                                placeholder="Username"
                            ></b-form-input>
                        </b-input-group>

                        <Feedback
                            :state="validateRef('registerForm.email')"
                            invalid="This field is required and must be a valid email"
                        ></Feedback>
                        <b-input-group class="mb-3">
                            <b-input-group-prepend>
                                <b-input-group-text>@</b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input
                                v-model="$v.registerForm.email.$model"
                                :disabled="lockEmail"
                                type="email"
                                class="form-control"
                                placeholder="Email"
                            ></b-form-input>
                        </b-input-group>

                        <Feedback
                            :state="validateRef('registerForm.password')"
                            invalid="This field is required"
                        ></Feedback>
                        <b-input-group class="mb-3">
                            <b-input-group-prepend>
                                <b-input-group-text>
                                    <i class="icon-lock"></i>
                                </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input
                                v-model="$v.registerForm.password.$model"
                                type="password"
                                class="form-control"
                                placeholder="Password"
                            ></b-form-input>
                        </b-input-group>

                        <Feedback
                            :state="validateRef('registerForm.repeatedPassword')"
                            invalid="This field is required and must equals password"
                        ></Feedback>
                        <b-input-group class="mb-4">
                            <b-input-group-prepend>
                                <b-input-group-text>
                                    <i class="icon-lock"></i>
                                </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input
                                v-model="$v.registerForm.repeatedPassword.$model"
                                type="password"
                                class="form-control"
                                placeholder="Repeat password"
                            ></b-form-input>
                        </b-input-group>

                        <Feedback :state="registerError.state" :invalid="registerError.message"></Feedback>
                        <b-button @click="register" variant="success login-button" block>Create account</b-button>
                    </b-card-body>
                    <b-card no-body class="text-white bg-primary py-5 d-md-down-none messageRegister">
                        <b-card-body class="text-center">
                            <div class="messageRegisterBox">
                                <p class="messegeRegisterText">You already have account?</p>
                                <b-button
                                    @click="$router.push('/auth/login')"
                                    variant="primary"
                                    class="active mt-3 messegeRegisterButton"
                                    >Login here!</b-button
                                >
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <b-modal v-model="showForbiddenModal" size="lg" centered hide-footer title="Email not allowed">
            <div class="d-block text-center">
                <h3>You cannot register here</h3>
                Your email is not recognized! Unfortunately, we can't create your account now. Please contact the admin
                if You think it's a mistake 😁
            </div>
            <b-button class="mt-2" variant="outline-warning" block @click="closeForbiddenModal">Close</b-button>
        </b-modal>
        <Loading :loading="$store.state.loading.processing" :text="$store.state.loading.text"></Loading>
    </div>
</template>

<script>
import {validationMixin} from 'vuelidate'

import {required, email, sameAs} from 'vuelidate/lib/validators'

import Feedback from '@/components/Feedback'
import Loading from '@/components/loading.vue'

export default {
    data() {
        return {
            registerForm: {
                username: '',
                email: '',
                password: '',
                repeatedPassword: '',
            },
            registerError: {
                state: true,
                message: '',
            },
            showForbiddenModal: false,
            invitationId: null,
            lockEmail: false,
        }
    },
    components: {
        Feedback,
        Loading,
    },
    mixins: [validationMixin],
    validations: {
        registerForm: {
            username: {
                required,
            },
            email: {
                required,
                email,
            },
            password: {
                required,
            },
            repeatedPassword: {
                required,
                sameAsPassword: sameAs(function() {
                    return this.registerForm.password
                }),
            },
        },
    },
    created() {
        const {invitationId} = this.$route.query
        if (invitationId) {
            this.invitationId = invitationId
            this.fetchInvitation()
        }
    },
    methods: {
        async fetchInvitation() {
            try {
                const response = await this.axios.get(
                    `${process.env.VUE_APP_NODE_API_HOST}/invitations/${this.invitationId}`
                )
                this.registerForm.email = response.data.data.emailInvited
                this.lockEmail = true
            } catch {}
        },
        closeForbiddenModal() {
            this.showForbiddenModal = false
        },
        async register() {
            try {
                this.registerError.state = true
                this.registerError.message = null

                if (this.$v.registerForm.$invalid) {
                    this.$v.registerForm.$touch()
                    return
                }

                this.$store.commit('loading/PROCESSING', `Registering...`)
                const user = await this.$auth.register({
                    data: {
                        name: this.registerForm.username,
                        email: this.registerForm.email,
                        password: this.registerForm.password,
                    },
                    success() {
                        localStorage.removeItem('activeProjectId')
                        this.$store.commit('loading/PROCESSED')
                    },
                })
            } catch (e) {
                this.$store.commit('loading/PROCESSED')
                if (e.response.status === 403) {
                    this.showForbiddenModal = true
                }
                this.registerError.state = false
                this.registerError.message = e.response.data
            }
        },
        validateRef(ref) {
            const keys = ref.split('.')
            const validateField = keys.reduce((a, c) => {
                return a[c]
            }, this.$v)

            return validateField.$dirty ? !validateField.$invalid : null
        },
    },
}
</script>
